import React from 'react';
//import { useParams } from 'react-router-dom';
import { supportednfts } from '../../lib/supportednfts';
import styled from "styled-components";
import NftCards from "../../components/tabs/NftCards"

const StyledWrapper = styled('div')(() => ({
    width: '100%',
    marginTop: '3rem',
}));

const Nft = ({ userSettings }) => {
    // const { contractId, nftId } = useParams();
    const pathSegments = window.location.pathname.split('/');
    const contractId = pathSegments[2] || null;
    const nftId = pathSegments[3] || null;

    console.log("contractId: ", contractId);
    console.log("nftId: ", nftId);

    const nftInfo = supportednfts[contractId];
    console.log("nftInfo: ", nftInfo);

    const imageUrl = nftInfo
        ? `${nftInfo.imagehostprefix}${nftId}${nftInfo.imagehostsuffix}`
        : '/32-default.png';

    return (
        <StyledWrapper>
            {nftInfo ? (
                <NftCards id={nftId} imageUrl={imageUrl} contractId={contractId} userSettings={userSettings} />
            ) : (
                <p style={{ color: '#F7931A' }}>Hmmm, this is awkward...</p>
            )
            }
        </StyledWrapper >
    );
};

export default Nft;